import axios from "../api/client"
import { useContext } from "react";
import { createContext, useState } from "react";

export const BlogContext = createContext();

export function BlogProvider({ children }) {
    const [blogs, setBlogs] = useState(null);
    const [alumni, setAlumni] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchBlogs = async () => {
        try {
            const response = await axios.get(`/blogs`);
            setBlogs(response.data);
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };
    
    const fetchBlogDetails = (uuid) => {
        axios
            .get(`${process.env.REACT_APP_DOMAIN_URL}/api/blogs/${uuid}`)
            .then((response) => {
                setBlogs(response.data);
                setIsLoading(false);
            })
            .catch((err) => {
                setError(err);
                setIsLoading(false);
            });
    };

    const fetchAlumni = async () => {
        try {
            const response = await axios.get(`/alumni`);
            setAlumni(response.data);
        } catch (err) {
            setError(err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <BlogContext.Provider value={{ blogs, isLoading, error, fetchBlogs, fetchBlogDetails,fetchAlumni, alumni }}>
            {children}
        </BlogContext.Provider>
    );
}
export const useContent = () => {
    const context = useContext(BlogContext);
    if (!context) {
      throw new Error('useContent must be used within a ContentProvider');
    }
    return context;
};